import React, { useState, useContext } from 'react'
import styled from 'styled-components'
import upload_img from '@assets/images/upload_img.svg'
import { myContext } from '@/redux/index.js'
import useWrapperIntl from '@/locales/useWrapperIntl'
import { AutoStretchBaseWidthOrHeightImg } from '@/pages/component/Other/autoStretchBaseWidthOrHeightImg'

const UploadStyled = styled.div`
    width: 620px;
    display: flex;
    /* margin-top: 22px; */

    .left_img{
        margin-right: 40px;
        width: ${({ width }) => { return width }};
        height:${({ height }) => { return height }};
        box-sizing: border-box;
        position: relative;
        &.avatar{
            width: 160px;
            height: 160px;
        }

        img{
            width: 100%;
            height: 100%;
        }

        input{
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            z-index: 1;
            cursor: pointer;
        }
        
    }
    

    .right_info{
        display: flex;
        flex-direction: column;
        justify-content: center;

        p{
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 12px;
            color: rgba(0,0,0,.7);
            width: 400px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        span{
            margin-top: 2px;
            color: rgba(0,0,0,.4);
            font-size: 13px;
            line-height: 15.51px;
        }
    }
`

export default function UploadAll({
    // type = 'image',
    onFileChange,
    onFilePathChange,
    defaultValue,
    disabled,
    lockInput,
    width = '240px',
    height = '160px',
    onClick
}) {
    const { dispatch } = useContext(myContext);
    const { wrapperIntl } = useWrapperIntl()
    const [coverSrc, setCoverSrc] = useState(upload_img)
    const [infoTitle, setInfoTitle] = useState(wrapperIntl("UIKit.Input.Upload.infoTip.uploadImageAndVideo"))
    const resetInfoTitle = () => {
        setInfoTitle(wrapperIntl("UIKit.Input.Upload.infoTip.uploadImageAndVideo"))
    }
    const handelFileChange = async (e) => {
        const file = e.target.files[0]
        if (!file) return
        let filetype = file.type
        // try {
        //     filetype = await getFileType(file)
        // } catch (error) {
        //     console.log(error)
        // }
        if (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/gif') {
            let reader = new FileReader();  //调用FileReader
            reader.readAsDataURL(file); //将文件读取为 DataURL(base64)
            reader.onload = function (evt) {   //读取操作完成时触发。
                setCoverSrc(evt.target.result)  //将img标签的src绑定为DataURL
                setInfoTitle(file.name)
                const data = reader.result.split(',')[1];
                const bufferData = Buffer.from(data, 'base64');
                const base64Path = window.URL.createObjectURL(new Blob([bufferData]));
                onFilePathChange && onFilePathChange(base64Path);
            }
            let formData = new FormData()
            formData.append('filename', file)
            
            onFileChange && onFileChange(formData, file, filetype)
            // setFormData(formData)
        } else if (file.type.includes('video/')) {
            console.log(file)
            if (file.size > 50 * 1024 * 1024 || file.type !== "video/mp4") {
                resetInfoTitle()
                dispatch({ type: 'Modal_Message', showMessageModal: true, modelType: 'error', modelMessage: wrapperIntl("UIKit.Input.Upload.infoTip.videoError") });
                return ;
            }
            let reader = new FileReader();  //调用FileReader
            reader.readAsDataURL(file); //将文件读取为 DataURL(base64)
            reader.onload = function (evt) {   //读取操作完成时触发。
                // setCoverSrc(evt.target.result)  //将img标签的src绑定为DataURL
                setInfoTitle(file.name)
                const data = reader.result.split(',')[1];
                const bufferData = Buffer.from(data, 'base64');
                const base64Path = window.URL.createObjectURL(new Blob([bufferData]));
                /** 视频上传的回调, 用于接收视频base64地址 */
                onFilePathChange && onFilePathChange(base64Path);
            }
            let formData = new FormData()
            formData.append('filename', file)
            onFileChange && onFileChange(formData, file, filetype)
        } else {
            dispatch({ type: 'Modal_Message', showMessageModal: true, modelType: 'error', modelMessage: wrapperIntl("UIKit.Input.Upload.infoTip.FormatIncorrect") });
        }
    }

    return (
        <UploadStyled width={width} height={height} >
            <div className={`left_img image`}>
                <AutoStretchBaseWidthOrHeightImg src={coverSrc} width={160} height={160} />
                <input disabled={disabled || lockInput} type="file" 
                accept="image/*,video/*"
                name="upload_file" onChange={handelFileChange} id="" onClick={onClick} />
            </div>
            <div className="right_info">
                <p>{infoTitle}</p>
                <span>{wrapperIntl('UIKit.Input.Upload.infoTip.requirementImageANdVideo')}</span>
                <span>{wrapperIntl('UIKit.Input.Upload.infoTip.image.requirementImageAndVideo')}</span>
            </div>
        </UploadStyled>
    )
}